import {useNavigate, useSearchParams} from "react-router-dom";
import {useShortBillBody} from "./ShortBill";
import "./ShortBill.css";

/*
 * Prints a millimetre ruler across the full roll width, starting at the printer's first dot.
 * The last number fully visible on the slip is how many mm this printer can reach — the
 * value for "Print Width (mm)" in Order Settings.
 */
function ShortBillAlignmentTest() {
    const navigate = useNavigate();
    const [params] = useSearchParams();
    const paperWidth = params.get('paper') === '58' ? 58 : 80;
    const ticks = Array.from({length: paperWidth + 1}, (_, mm) => mm);
    // Every 10mm, plus every 2mm near the right edge where printers cut off. Near-edge labels
    // alternate between two rows so 2-digit numbers 2mm apart don't overlap.
    const fineFrom = paperWidth - 20;
    const labels = ticks
        .filter((mm) => mm % 10 === 0 || (mm >= fineFrom && mm % 2 === 0))
        .map((mm) => ({mm, lower: mm >= fineFrom && mm % 4 === 2}));

    useShortBillBody();

    return (
        <div className="short-bill-page">
            {/* Must be taller than wide: a wider page is treated as landscape and printed rotated */}
            <style>{`@page { size: ${paperWidth}mm ${paperWidth + 5}mm; margin: 0; }`}</style>

            <div className="short-bill-toolbar">
                <button type="button" onClick={() => window.print()}>Print test</button>
                <button type="button" onClick={() => navigate('/settings/order-settings')}>Back to settings</button>
            </div>
            <div className="short-bill-tip">
                Tip: in the print dialog, open More settings and set Margins to <b>Minimum</b>.
            </div>

            <div className="sb-ruler-sheet" style={{width: `${paperWidth}mm`}}>
                <div className="sb-ruler-title">ALIGNMENT TEST ({paperWidth}mm paper)</div>
                <div className="sb-ruler" style={{width: `${paperWidth}mm`}}>
                    {ticks.map((mm) => (
                        <div
                            key={mm}
                            className={`sb-tick ${mm % 10 === 0 ? 'sb-tick-10' : mm % 5 === 0 ? 'sb-tick-5' : ''}`}
                            style={{left: `${mm}mm`}}
                        />
                    ))}
                    {labels.map(({mm, lower}) => (
                        <div key={`l${mm}`} className={`sb-tick-label ${lower ? 'sb-tick-label-lower' : ''}`}
                             style={{left: `${mm}mm`}}>{mm}</div>
                    ))}
                </div>
                <div className="sb-ruler-help">
                    Note the last number you can fully read on the right and enter it as Print Width (mm).
                </div>
            </div>
        </div>
    );
}

export default ShortBillAlignmentTest;
